// Logo/Bild clientseitig verkleinern – Seitenverhältnis bleibt immer erhalten
export async function resizeImageFile(file, { maxSize = 900, maxBytes = 400 * 1024 } = {}) {
  const dataUrl = await new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = (ev) => resolve(ev.target?.result || "");
    r.onerror = reject;
    r.readAsDataURL(file);
  });
  const img = await new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = reject;
    i.src = dataUrl;
  });
  const ratio = Math.min(1, maxSize / Math.max(img.naturalWidth, img.naturalHeight));
  let w = Math.max(1, Math.round(img.naturalWidth * ratio));
  let h = Math.max(1, Math.round(img.naturalHeight * ratio));
  if (ratio === 1 && file.size <= maxBytes) return { dataUrl, width: w, height: h, resized: false };

  const hasAlpha = file.type === "image/png" || file.type === "image/webp";
  let out = dataUrl;
  for (let attempt = 0; attempt < 6; attempt++) {
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(img, 0, 0, w, h);
    out = hasAlpha ? canvas.toDataURL("image/png") : canvas.toDataURL("image/jpeg", 0.88);
    if (out.length * 0.75 <= maxBytes) break;
    w = Math.round(w * 0.8);
    h = Math.round(h * 0.8);
  }
  return { dataUrl: out, width: w, height: h, resized: true };
}
